/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Prompt_Screening_EnabledInputs */

const en_admin_settings_fields_prompt_screening_enabled = /** @type {(inputs: Admin_Settings_Fields_Prompt_Screening_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prompt screening (Waffo)`)
};

/**
* | output |
* | --- |
* | "Prompt screening (Waffo)" |
*
* @param {Admin_Settings_Fields_Prompt_Screening_EnabledInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_prompt_screening_enabled = /** @type {((inputs?: Admin_Settings_Fields_Prompt_Screening_EnabledInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Prompt_Screening_EnabledInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_prompt_screening_enabled(inputs)
});
export { admin_settings_fields_prompt_screening_enabled as "admin.settings.fields.prompt_screening_enabled" }